module.exports = __webpack_public_path__ + "assets/img/20_79.45f42b2c.jpg";